import React, { useState } from "react";
import { deleteUser } from "../Admin/Api.js"; // Deine API-Funktion zum Löschen des Benutzers

const DeleteUser = ({ username, handleLogout, setError }) => {
  const [isDeleting, setIsDeleting] = useState(false); // Zustand, um den Löschvorgang anzuzeigen
  const [loading, setLoading] = useState(false); // Zustand für den Ladeindikator
  const [confirmDelete, setConfirmDelete] = useState(false); // Zustand für Bestätigung des Löschens

  const handleDelete = async () => {
    if (!username || username === "null") {
      console.error("Benutzername nicht gefunden!");
      setError("Benutzername nicht gefunden!");
      return;
    }

    setLoading(true); // Ladeindikator aktivieren
    setIsDeleting(true); // Zeige den Löschvorgang an

    try {
      // API-Aufruf zum Löschen des Benutzers
      await deleteUser(username);
      alert("Account wurde erfolgreich gelöscht!");

      // Benutzer ausloggen und zur Login-Seite weiterleiten
      handleLogout(); // Logout-Funktion aus der Props aufrufen
    } catch (error) {
      console.error("Fehler beim Löschen des Accounts:", error);
      setError("Fehler beim Löschen des Accounts. Bitte versuche es später.");
    } finally {
      setLoading(false); // Ladeindikator deaktivieren
      setIsDeleting(false); // Löschvorgang beenden
    }
  };

  return (
    <div className="delete-user-container">
      {/* Button zum Bestätigen des Löschvorgangs */}
      {!confirmDelete ? (
        <button
          onClick={() => setConfirmDelete(true)} // Bestätigung anfordern
          className="delete-account-button"
        >
          Account löschen
        </button>
      ) : (
        // Wenn bestätigt, zwei Buttons: "Löschen" und "Abbrechen"
        <div>
          <p>Willst du wirklich deinen Account löschen?</p>
          <button
            onClick={handleDelete}
            className="delete-account-confirm-button"
            disabled={loading} // Button während des Löschvorgangs deaktivieren
          >
            {loading ? "Löschen..." : "Ja, löschen"}
          </button>
          <button
            onClick={() => setConfirmDelete(false)} // Bestätigung abbrechen
            className="delete-account-cancel-button"
          >
            Abbrechen
          </button>
        </div>
      )}

      {isDeleting && <p>Benutzer wird gelöscht...</p>} {/* Ladeanzeige */}
    </div>
  );
};

export default DeleteUser;
